import React from 'react';
import Card from '../../../components/ui/Card';

const NotificationFilters = ({ filters, onFilterChange }) => {
  return (
    <Card className="p-4 mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">Type</label>
          <select
            value={filters?.type}
            onChange={(e) => onFilterChange({ ...filters, type: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Types</option>
            <option value="expiry_alert">Expiry Alerts</option>
            <option value="vacancy_alert">Vacancy Alerts</option>
            <option value="lead_sla_alert">Lead SLA Alerts</option>
            <option value="renewal_reminder">Renewal Reminders</option>
            <option value="email_trigger">Email Triggers</option>
            <option value="system_alert">System Alerts</option>
          </select>
        </div>

        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">Priority</label>
          <select
            value={filters?.priority}
            onChange={(e) => onFilterChange({ ...filters, priority: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Priorities</option>
            <option value="critical">Critical</option>
            <option value="high">High</option>
            <option value="medium">Medium</option>
            <option value="low">Low</option>
          </select>
        </div>

        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">Status</label>
          <select
            value={filters?.isRead}
            onChange={(e) => onFilterChange({ ...filters, isRead: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Status</option>
            <option value="unread">Unread</option>
            <option value="read">Read</option>
          </select>
        </div>
      </div>
    </Card>
  );
};

export default NotificationFilters;